var _path, _path2, _path3, _path4, _path5, _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgViewempty(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 110,
    viewBox: "0 0 200 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M191.617 22C196.247 22 200 25.7533 200 30.3832C200 35.0132 196.247 38.7665 191.617 38.7665H143.713C148.342 38.7665 152.096 42.5198 152.096 47.1497C152.096 51.7796 148.342 55.5329 143.713 55.5329H170.06C174.69 55.5329 178.443 59.2862 178.443 63.9162C178.443 68.5461 174.69 72.2994 170.06 72.2994H157.876C152.038 72.2994 147.305 76.0527 147.305 80.6826C147.305 83.7693 149.701 86.5637 154.491 89.0659C159.121 89.0659 162.874 92.8192 162.874 97.4491C162.874 102.079 159.121 105.832 154.491 105.832H55.0898C50.4599 105.832 46.7066 102.079 46.7066 97.4491C46.7066 92.8192 50.4599 89.0659 55.0898 89.0659H8.38323C3.7533 89.0659 0 85.3126 0 80.6826C0 76.0527 3.7533 72.2994 8.38323 72.2994H56.2874C60.9174 72.2994 64.6707 68.5461 64.6707 63.9162C64.6707 59.2862 60.9174 55.5329 56.2874 55.5329H26.3473C21.7174 55.5329 17.9641 51.7796 17.9641 47.1497C17.9641 42.5198 21.7174 38.7665 26.3473 38.7665H74.2515C69.6216 38.7665 65.8683 35.0132 65.8683 30.3832C65.8683 25.7533 69.6216 22 74.2515 22H191.617ZM191.617 55.5329C196.247 55.5329 200 59.2862 200 63.9162C200 68.5461 196.247 72.2994 191.617 72.2994C186.987 72.2994 183.234 68.5461 183.234 63.9162C183.234 59.2862 186.987 55.5329 191.617 55.5329Z",
    fill: "#D6DCE8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M152.7 10.6C154.246 10.6 155.5 9.3464 155.5 7.8C155.5 6.2536 154.246 5 152.7 5C151.154 5 149.9 6.2536 149.9 7.8C149.9 9.3464 151.154 10.6 152.7 10.6Z",
    fill: "#E7EBF6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3 21.5004C47.8464 21.5004 49.1 20.2468 49.1 18.7004C49.1 17.154 47.8464 15.9004 46.3 15.9004C44.7536 15.9004 43.5 17.154 43.5 18.7004C43.5 20.2468 44.7536 21.5004 46.3 21.5004Z",
    fill: "#E7EBF6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2 80.4996C37.0719 80.4996 39.4 78.1715 39.4 75.2996C39.4 72.4277 37.0719 70.0996 34.2 70.0996C31.3281 70.0996 29 72.4277 29 75.2996C29 78.1715 31.3281 80.4996 34.2 80.4996Z",
    fill: "#E7EBF6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.9055 108.978C96.8641 109.026 94.8378 108.615 92.977 107.774L48.7686 85.6846C46.346 84.4809 45.9849 82.7805 45.9849 81.8928C45.9849 79.9667 47.5347 78.0859 50.2582 76.7316L63.289 70.2012L92.029 84.5712C96.7388 86.9185 103.916 86.106 108.476 83.8339L135.711 70.2162L150.231 77.4539C152.654 78.6576 153.015 80.358 153.015 81.2608C153.015 83.1868 151.465 85.0677 148.742 86.422L107.543 107.036C104.97 108.3 101.81 108.978 98.9055 108.978Z",
    fill: "#ECF0F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_42439_26247)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.9055 83.8805C96.8641 83.9293 94.8378 83.5179 92.977 82.6767L48.7686 60.5876C46.346 59.3988 45.9849 57.7136 45.9849 56.8107C45.9849 54.8847 47.5347 53.0038 50.2582 51.6496L63.289 45.1191L92.029 59.4891C96.7388 61.8365 103.916 61.039 108.46 58.7518L135.711 45.1342L150.231 52.3869C152.654 53.5907 153.015 55.291 153.015 56.1788C153.015 58.1048 151.465 59.9857 148.742 61.3399L107.543 81.9545C104.97 83.2184 101.81 83.8805 98.9055 83.8805Z",
    fill: "#F5F7FA"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_42439_26247)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.9055 58.7961C96.8641 58.8449 94.8378 58.4335 92.977 57.5923L48.7686 35.5333C46.346 34.3295 45.9849 32.6442 45.9849 31.7414C45.9849 29.8304 47.5347 27.9495 50.2582 26.5802L91.4723 5.95065C95.9563 3.69358 102.351 3.39264 106.008 5.19829L150.216 27.3025C152.624 28.5063 152.985 30.2066 152.985 31.1094C152.985 33.0204 151.45 34.9013 148.727 36.2706L107.512 56.8701C104.954 58.134 101.81 58.7961 98.9055 58.7961Z",
    fill: "#F5F7FA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_42439_26247",
    x: 33.6449,
    y: 44.9516,
    width: 127.71,
    height: 59.4456,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2,
    dy: 10.1725
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.17
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.17 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_42439_26247"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_42439_26247",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_42439_26247",
    x: 35.6449,
    y: 3.85786,
    width: 127.68,
    height: 75.4554,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10.1725
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.17
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_42439_26247"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_42439_26247",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewempty);
export default __webpack_public_path__ + "static/media/viewempty.92b79f811c7ca05a0a4e670e9d3d793c.svg";
export { ForwardRef as ReactComponent };